import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader, Container } from "reactstrap"
import { RentForm } from "./RentForm"
import { useState } from "react"
import LoadScreen from "../UI/LoadScreen"
import { CorporateForm } from "./CorporateForm"
import { useForm } from "react-hook-form"
import { useCreateCorporateRequestMutation, useCreateRentRequestMutation } from "../../features/CallApi"
import { RequestsCompletion } from "./RequestsCompletion"


export const Requests = () => {

    const [serviceType, setServiceStype] = useState()
    const [requestStatus, setRequestStatus] = useState(null)
    const [posting, setPosting] = useState(null)
    const { register, handleSubmit, reset, formState: { errors }, setValue, clearErrors } = useForm();
    const [createCorporateRequest, { isLoading: postingCorporateForm }] = useCreateCorporateRequestMutation()
    const [createRentRequest, { isLoading: postingRentForm }] = useCreateRentRequestMutation()

    const [loadingAnim, setLoadiingAnim] = useState(false)
    const selectForm = (typeId) => {
        setLoadiingAnim(true)
        setServiceStype(typeId)
        setTimeout(() => {
            setLoadiingAnim(false)
        }, 1000)
        reset()
        setValue("service", typeId ? typeId : "")
    }

    const sendRequst = (data) => {
        setPosting(true)
        setTimeout(() => {
            data.service = parseInt(data.service)
            data.nop = parseInt(data.nop)
            console.log(data)
            if (data.service === 0) {
                createRentRequest(data).unwrap()
                    .then((response) => {
                        setRequestStatus(true)
                        console.log(response)
                        setPosting(postingRentForm)
                    })
                    .catch(() => {
                        setRequestStatus(false)
                        setPosting(postingRentForm)
                    })
            }
            if (data.service === 1) {
                data.session = parseInt(data.session)
                createCorporateRequest(data).unwrap()
                    .then((response) => {
                        setRequestStatus(true)
                        console.log(response)
                        setPosting(postingCorporateForm)
                    })
                    .catch(() => {
                        setRequestStatus(false)
                        setPosting(postingCorporateForm)
                    })
            }
        }, 500)
    }

    const restForm = () => {
        reset()
        setPosting(null)
        setRequestStatus(null)
        setServiceStype(null)
    }

    return (
        window.location.href = 'https://leningradcenter.ru/about-project/requests'
    )

    return (
        <Container>
            <div>
                {(posting || requestStatus != null) ?
                    <RequestsCompletion restForm={restForm} posting={posting} requestStatus={requestStatus} /> :
                    <div>
                        <div className="hader-requests"></div>
                        <form onSubmit={handleSubmit(sendRequst)}>
                            <Card className="mt-3">
                                <CardHeader><h3>Форма обращения</h3></CardHeader>
                                <CardBody>
                                    <p><span className="text-danger">*</span> - поля обязательные для заполнения</p>
                                    <div className="row mb-2">
                                        <div className="col-md">
                                            <div className="form-floating w-100">
                                                <select defaultValue="" name="service"
                                                    {...register("service", { required: { value: true, message: "Выбирете тему обращения" } })}
                                                    onChange={(e) => {
                                                        selectForm(e.target.value)
                                                    }}
                                                    id="service" className={`form-select ${errors.service && "is-invalid"}`}>
                                                    <option hidden value="">-- Выберете тему обращения --</option>
                                                    <option value="0">Организация частных мероприятий</option>
                                                    <option value="1">Продажа билетов юридическим лицам</option>
                                                </select>
                                                <label htmlFor="service">Тема запроса<span className="text-danger">*</span></label>
                                            </div>
                                            {errors.service && <span className='text-danger'>{errors.service?.message}</span>}
                                        </div>
                                    </div>
                                    {!loadingAnim ?
                                        <>
                                            {/* {!serviceType ? <p>Выберите тему обращения</p> : <></>} */}
                                            {serviceType === "0" ? <RentForm register={register} errors={errors} setValue={setValue} /> : <></>}
                                            {serviceType === "1" ? <CorporateForm register={register} errors={errors} setValue={setValue} clearErrors={clearErrors} /> : <></>}
                                            <div className="form-check">
                                                <label className="form-check-label">
                                                    <input type="checkbox" className="form-check-input" {...register("policy",
                                                        { required: { value: true, message: "Необходимо согласие на обработку персональных данных" } })} />
                                                    Согласие на обработку персональных данных <br /> <a href="https://casting.leningradcenter.ru/Content/Files/policy_personal_data_1584092575.pdf">Политика конфиденциальности</a>
                                                </label>
                                                <div>
                                                    {errors.policy && <span className='text-danger'>{errors.policy?.message}</span>}
                                                </div>
                                            </div>
                                        </>
                                        : <LoadScreen height={35} />}
                                </CardBody>
                                <CardFooter>
                                    <ButtonGroup>
                                        <Button disabled={posting} color="success">Отправить</Button>
                                    </ButtonGroup>
                                </CardFooter>
                            </Card>
                        </form>
                    </div>
                }
            </div>
        </Container>
    )
}